<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
   <div style="text-align:right; margin-top:90px;">
			 <p-button type="info"  @click="goToEntityDocuments()" >
			  <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
					  Document Browser
					  </p-button>      
		  </div>
	
	
   <h4  class="card-title">
     Edit Folder 
    </h4>
		  
	 <card class="form-horizontal">
   
    

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Folder Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="folder_name"
                  v-model="model.folder_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
        <div class="row">
		  <label class="col-sm-2 col-form-label">Visibility</label>
		  <div class="col-sm-7">
			<fg-input>
					  <el-select class="select-primary"
								 size="large"
								 placeholder=""
								 v-model="model.public">
						<el-option v-for="option in selects.visibility"
								   class="select-danger"
								   :value="option.value"
								   :label="option.label"
								   :key="option.label">
						</el-option>
					  </el-select>
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			<code></code>
		  </div>
		</div>
    
    
    
    
    </card>
    
    
    <p-button  type="info" @click.prevent="editFolder">Edit Folder</p-button>

    
    
          
      

  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	
       
       if(this.$route.params.eid!=0){
     
			let uri = this.$base_url+'/api/v1/documents/get/folder_info/'+ this.$route.params.fid +"/"+this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
				this.model = response.data.folder;
			
			})
      	}//get connected entity info
      
     	 	
      
    },
    
     
    data () {
      return {
        coy:[],
        model:[],
        variables:[],
        folders:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	task_id:this.$route.params.tid,
    	createForm: true,
    	loadCommon: false,
    	loadInfo: false,
    	new_folder_name:"",
        new_tag_name:"",
         selects: {
          visibility: [
            {value: 1, label: 'Public'},
            {value: 2, label: 'Private'},

		   ],
		  }
    	
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    goToTask(){
       		this.$router.push( '/edit-task/'+ this.task_id + '/entity/'+ this.$route.params.eid)
       },
        goToEntityDocuments(){
      		 this.$router.push( '/entity-documents/'+this.$route.params.eid)  
       },
       

	     
       displayErrorMessage(msg){
        		swal({
					  title: 'Error!',
					  text: msg,
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
    	onIsCompanyRepChange(event){
       		if(this.model.is_company == 1){

       			this.displayCompanyForm = true;
       		}
       		else{
       			this.displayCompanyForm = false;
       		}
       
       },
 
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
    goToEditFolder(row){
      	 this.$router.push( '/edit-folder/'+row.id+"/entity/"+this.$route.params.eid);
      	 
      },

      editFolder() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
  		  	
    		let uri = this.$base_url+'/api/v1/documents/post/update_folder/'+this.$route.params.fid+"/"+this.$route.params.eid;
      		ApiService.post(uri, this.model).then(response => {
         			this.$router.push( '/entity-documents/'+this.$route.params.eid)  
         			
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


